module.exports = __webpack_public_path__ + "static/media/photo283.97752d1e.jpg";